import { LanguageToggle, useLanguage } from "../i18n/Language";
import React from 'react';

export const appointmentWhatsApp = 'https://wa.me/917893107890?text=' + encodeURIComponent('Hello Dr. Bharat Reddy Katta, I would like to book an orthopaedic consultation in L.B. Nagar. Please share available appointment timings.');

export function useAppointmentWhatsApp() {
  const { language } = useLanguage();
  return language === 'te' ? 'https://wa.me/917893107890?text=' + encodeURIComponent('నమస్కారం డా. భరత్ రెడ్డి కట్టా గారు, ఎల్.బి. నగర్‌లో ఎముకలు, కీళ్ల సమస్యల కోసం అపాయింట్‌మెంట్ బుక్ చేసుకోవాలనుకుంటున్నాను. అందుబాటులో ఉన్న సమయాలు తెలియజేయండి.') : appointmentWhatsApp;
}

export default function QuickContact() {
  const { t } = useLanguage();
  const appointmentWhatsApp = useAppointmentWhatsApp();
  return <><LanguageToggle floating />
    <a href={appointmentWhatsApp} target="_blank" rel="noopener noreferrer" className="floating-whatsapp" aria-label={t("Book an appointment with Dr. Bharat Reddy Katta on WhatsApp")}>
      <i className="fab fa-whatsapp" aria-hidden="true" />
    </a>
    <a href="tel:+917893107890" className="floating-call" aria-label={t("Call Dr. Bharat Reddy Katta")}>
      <i className="fas fa-phone" aria-hidden="true" />
    </a>
    <a href="tel:+917893107890" className="mobile-call-bar"><i className="fas fa-phone" aria-hidden="true" />{t(" Call Dr. Bharat Reddy Katta")}</a>
  </>;
}
